<template>
  <div class="min-h-screen bg-white dark:bg-gray-900">
    <!-- Header -->
    <AppHeader />
    
    <!-- Main Content -->
    <main class="pt-16">
      <!-- Hero Section -->
      <HeroSection />
      
      <!-- About Section -->
      <AboutSection />
      
      <!-- Skills Section -->
      <SkillsSection />
      
      <!-- Projects Section -->
      <ProjectsSection />
      
      <!-- Experience Section -->
      <ExperienceSection />
      
      <!-- Education Section -->
      <EducationSection />
      
      <!-- Contact Section -->
      <ContactSection />
    </main>
    
    <!-- Footer -->
    <AppFooter />
  </div>
</template>

<script setup>
import AppHeader from '../components/AppHeader.vue'
import HeroSection from '../components/HeroSection.vue'
import AboutSection from '../components/AboutSection.vue'
import SkillsSection from '../components/SkillsSection.vue'
import ProjectsSection from '../components/ProjectsSection.vue'
import ExperienceSection from '../components/ExperienceSection.vue'
import EducationSection from '../components/EducationSection.vue'
import ContactSection from '../components/ContactSection.vue'
import AppFooter from '../components/AppFooter.vue'

// Vue requires multi-word component names, so we'll use defineOptions to set the component name
import { defineOptions } from 'vue'
defineOptions({
  name: 'HomePage'
})
</script> 